import React, { Component } from "react";
import styled from "styled-components";

import { get } from "./common/fetch";
import { withGettext } from "./common/Gettext";
import { isWebKitWebViewIOSApp } from "./utils";
import ReferralsPopup from "./ReferralsPopup";
import ReferralsLink from "./ReferralsLink";

const Container = styled.div`
  display: flex;
  justify-content: flex-end;
`;

function getParameterByName(name, url) {
  if (!url) {
    url = window.location.href;
  }
  name = name.replace(/[[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

class ReferralsShareLinks extends Component {
  state = {
    showPopup: false,
    popupData: {},
    popupSuccess: "",
    popupResponse: ""
  };

  constructor(props) {
    super(props);

    this.onShowPopup = this.onShowPopup.bind(this);
    this.onHidePopup = this.onHidePopup.bind(this);
    this.onPopupSubmit = this.onPopupSubmit.bind(this);
    this.sendLinkOnEmail = this.sendLinkOnEmail.bind(this);
    this.sendLinkViaSMS = this.sendLinkViaSMS.bind(this);
  }

  componentDidMount() {
    const share = getParameterByName("share_param");

    if (share && (share === "phone" || share === "email")) {
      let title = "Enter friend's email";
      if (share === "phone") {
        title = "Enter friend's phone";
      }

      this.onShowPopup({
        title: this.props.gettext(title),
        submitTitle: this.props.gettext`Send`,
        type: share === "phone" ? "tel" : "email"
      });
    }
  }

  openWindow(url, title, params) {
    window.open(url, title, params);
  }

  sendLinkOnEmail(value) {
    this.setState({
      sendingEmail: true
    });

    get(`/ajax/shareRefEmail?email=${value}`)
      .catch(error => error)
      .then(data => {
        this.setState({
          sendingEmail: false,
          popupSuccess: data.status === "OK",
          popupResponse: data.message
        });
      });
  }

  sendLinkViaSMS(value) {
    this.setState({
      sendingText: true
    });

    get(`/ajax/shareRefSms?phone=${value}`)
      .catch(error => error)
      .then(data => {
        this.setState({
          sendingText: false,
          popupSuccess: data.status === "OK",
          popupResponse: data.message
        });
      });
  }

  onShowPopup(popupData) {
    this.setState({
      showPopup: true,
      popupData
    });
  }

  onHidePopup() {
    this.setState({
      showPopup: false,
      sendingEmail: false,
      sendingText: false,
      popupData: {},
      popupSuccess: "",
      popupResponse: ""
    });
  }

  onPopupSubmit(value) {
    switch (this.state.popupData.type) {
      case "email":
        this.sendLinkOnEmail(value);
        break;
      case "tel": {
        this.sendLinkViaSMS(value);
        break;
      }
      default:
        break;
    }
  }

  render() {
    const {
      projectName,
      minDepo,
      refBonus,
      desktop,
      isIndexPage,
      isTournament,
      link,
      prize,
      tournamentTitle,
      hideName,
      hideEmail
    } = this.props;

    const shareTitle = this.props.shareTitle ? this.props.shareTitle : this.props
      .gettext`I invite you to get a bonus on ${projectName}`;
    const shareText = this.props.shareText
      ? this.props.shareText
      : isTournament && process.env.REACT_APP_DEPLOY_TARGET === "irontrade"
      ? this.props.gettext(
          [
            "I earn ",
            ' in "',
            '" tournament on IronTrade! Register by my referal link ',
            ", trade, invest and try tournaments!",
          ],
          prize,
          tournamentTitle,
          link
        )
      : this.props
          .gettext`Good news everyone! Now you can register on ${projectName} using my link ${link}, trade and make money. If you deposit more than ${minDepo} in a one-time payment during 7 days after registration, then both of us will get ${refBonus} as a bonus.`;

    return (
      <Container>
        {this.state.showPopup && (
          <ReferralsPopup
            onClose={this.onHidePopup}
            onSubmit={this.onPopupSubmit}
            title={this.state.popupData.title}
            submitTitle={this.state.popupData.submitTitle}
            type={this.state.popupData.type}
            requestSuccess={this.state.popupSuccess}
            responseMessage={this.state.popupResponse}
            sending={
              this.state.popupData.type === "email"
                ? this.state.sendingEmail
                : this.state.sendingText
            }
          />
        )}

        <ReferralsLink
          id="facebook"
          name="Share"
          onClick={() => {
            const u = encodeURIComponent(link);
            const quote = encodeURIComponent(shareText);

            if (isWebKitWebViewIOSApp()) {
              const value = encodeURIComponent(
                `https://www.facebook.com/sharer/sharer.php?u=${u}&quote=${quote}`
              );
              window.location.href = `ios://sharing?value=${value}`;
            } else {
              this.openWindow(
                `https://www.facebook.com/sharer/sharer.php?u=${u}&quote=${quote}`,
                "Facebook",
                "width=626,height=436"
              );
            }
          }}
          desktop={desktop}
          isIndexPage={isIndexPage || isTournament}
          hideName={hideName}
        />

        <ReferralsLink
          id="twitter"
          name="TWEET"
          onClick={() => {
            const text = encodeURIComponent(shareText);

            if (isWebKitWebViewIOSApp()) {
              const value = encodeURIComponent(
                `http://twitter.com/intent/tweet?text=${text}`
              );
              window.location.href = `ios://sharing?value=${value}`;
            } else {
              this.openWindow(
                `http://twitter.com/intent/tweet?text=${text}`,
                "Twitter",
                "toolbar=0,status=0,width=626,height=436"
              );
            }
          }}
          desktop={desktop}
          isIndexPage={isIndexPage || isTournament}
          hideName={hideName}
        />

        {!isTournament && !hideEmail && (
          <ReferralsLink
            id="email"
            name="EMAIL"
            onClick={() => {
              const title = encodeURIComponent(shareTitle);
              const text = encodeURIComponent(shareText);
              window.location.href = `mailto:?subject=${title}&body=${text}`;
            }}
            desktop={desktop}
            isIndexPage={isIndexPage}
            hideName={hideName}
          />
        )}
      </Container>
    );
  }
}

export default withGettext(ReferralsShareLinks);



// WEBPACK FOOTER //
// ./src/components/ReferralsShareLinks.js